import * as yup from 'yup'

const schema = yup.object().shape({
  content: yup
    .string()
    .richTextRequired(
      'Adicione uma mensagem para publicar ou alterar o status',
    ),
  complaintStatus: yup.string().required(),
  attachments: yup.mixed().fileUpload(),
})

export default schema
